import client from "../client"

export const joinMotibell = async ({ motibellNo }) => {
	const form = {}

	const response = await client.post(`/motibells/${motibellNo}/participants`, form)

	return response.data
}
